import {faChevronDown, faChevronUp} from '@fortawesome/pro-solid-svg-icons';
import {
  Content,
  Portal,
  ScrollDownButton,
  ScrollUpButton,
  Viewport,
} from '@radix-ui/react-select';
import clsx from 'clsx';

import {Icon} from '../Icon/Icon';

type Props = React.ComponentPropsWithRef<typeof Content>;
export const SelectContent = ({
  ref: forwardedRef,
  className,
  children,
  ...props
}: Props & {
  ref?: React.RefObject<HTMLDivElement>;
}) => {
  return (
    <Portal>
      <Content
        {...props}
        ref={forwardedRef}
        className={clsx(
          'max-h-radix-select-content-available max-w-radix-select-content-available overflow-hidden rounded-md bg-slate1 py-1 text-base shadow-lg outline-1! -outline-offset-1 outline-slate6! focus-visible:outline-2! sm:text-sm',
          className
        )}
      >
        <ScrollUpButton className="flex h-[25px] cursor-default items-center justify-center text-slate11">
          <Icon icon={faChevronUp} aria-hidden="true" />
        </ScrollUpButton>

        <Viewport>{children}</Viewport>

        <ScrollDownButton className="flex h-[25px] cursor-default items-center justify-center text-slate11">
          <Icon icon={faChevronDown} aria-hidden="true" />
        </ScrollDownButton>
      </Content>
    </Portal>
  );
};

SelectContent.displayName = 'SelectContent';
